import { ITab } from './../../components/TabsWithContent'
import {
  ICompanyMemberPure,
  IRelationshipBasedSettings,
  ICompanyPure,
  ICompanyTerm,
  ICompanyJobLevelPure,
  ICompanyJobLevel,
  ICompanyJobPure,
  ICompany,
  ICompanyCultureValue,
} from './../models/Company'
import {
  isMemberBuddyOfAnotherMember,
  isMemberGenerallyLeadOfMember,
} from './isLeadOf'

export const getCurrentTerm = (
  company: ICompanyPure
): ICompanyTerm | undefined => {
  return company.termsInformation.terms.find(
    (term) => term.termNumber === company.state.currentTermNumber
  )
}

export const getCultureTabs = (
  cultureValue: ICompanyCultureValue,
  memberLevel?: ICompanyJobLevelPure
): ITab[] | undefined => {
  return cultureValue.levels?.length === 1
    ? (cultureValue.levels[0].description || '').length === 0
      ? undefined
      : [
          {
            richText: cultureValue.levels[0].description || '',
            openByDefault: true,
          },
        ]
    : cultureValue.levels
        .map((level) => {
          return {
            tag: level.title,
            richText: level.description || '',
            openByDefault: level.cultureRankId === memberLevel?.cultureRankId,
            rank: level.rank,
          }
        })
        .sort((a, b) => a.rank - b.rank)
}

export const getAllowedContributors = (
  company: ICompanyPure | ICompany,
  scoredMember: ICompanyMemberPure,
  settings?: IRelationshipBasedSettings | undefined
): ICompanyMemberPure[] => {
  const members = 'allMembers' in company ? company.allMembers : company.members
  const config = settings || company.settings?.evaluations?.scoreContributors
  if (!config) {
    return members
  }
  return members.flatMap((m) => {
    const isSelf = String(m._id) === String(scoredMember._id)
    if (config.self && isSelf) {
      return m
    }
    const isBuddy = isMemberBuddyOfAnotherMember(m, scoredMember)
    if (config.buddies && isBuddy && !isSelf) {
      return m
    }
    const isLead = isMemberGenerallyLeadOfMember(m, scoredMember)
    if (config.leads && isLead) {
      return m
    }

    if (config.peers && !isSelf && !isBuddy && !isLead) {
      return m
    }
    return []
  })
}

/**
 * @returns mutable reference to job object inside the company
 */
export const getJobLevelById = (
  levelId: string,
  company: ICompanyPure
): {
  level: ICompanyJobLevelPure | undefined
  job: ICompanyJobPure | undefined
} => {
  if (!company.jobs) {
    return { level: undefined, job: undefined }
  }
  const job = company.jobs.find((j) =>
    j.levels.some((l) => l._id + '' === levelId + '')
  )
  const level =
    levelId !== undefined && job
      ? job.levels.find((jobLevel) => levelId + '' === jobLevel._id + '')
      : undefined

  return { level, job }
}

export const getJobsAttachedToSkill = (
  skillId: string,
  company: ICompanyPure
): ICompanyJobLevel[] | undefined => {
  return company.jobs.flatMap((j) =>
    j.levels.filter((l) => l.skillsIds.includes(skillId))
  )
}
